import { buildActionButtonsControllerBindings } from '@/components/action-buttons/action-buttons-controller-bindings.builder';
import { useActionButtonsControllerOrchestration } from '@/components/action-buttons/use-action-buttons-controller-orchestration';
import type {
    ActionButtonsControllerParams,
    ActionButtonsControllerValue,
} from '@/components/action-buttons/action-buttons-controller.types';

export const useActionButtonsController = ({
    activeTable,
}: ActionButtonsControllerParams): ActionButtonsControllerValue => {
    const orchestration = useActionButtonsControllerOrchestration({ activeTable });

    return buildActionButtonsControllerBindings(orchestration);
};
